import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Synopsis`}</h3>
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/version.js */
    }
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm version [<newversion> | major | minor | patch | premajor | preminor | prepatch | prerelease | from-git]

alias: verison
`}</code></pre>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/version.js */
    }
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS END */
    }
    <h3>{`Configuration`}</h3>
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`allow-same-version`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Prevents throwing an error when `}<inlineCode parentName="p">{`npm version`}</inlineCode>{` is used to set the new version
to the same value as the current version.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`commit-hooks`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: true`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Run git commit hooks when using the `}<inlineCode parentName="p">{`npm version`}</inlineCode>{` command.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`git-tag-version`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: true`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Tag the commit when using the `}<inlineCode parentName="p">{`npm version`}</inlineCode>{` command. Setting this to false
results in no commit being made at all.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`json`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Whether or not to output JSON data, rather than the normal output.`}</p>
    <ul>
      <li parentName="ul">{`In `}<inlineCode parentName="li">{`npm pkg set`}</inlineCode>{` it enables parsing set values with JSON.parse() before
saving them to your `}<inlineCode parentName="li">{`package.json`}</inlineCode>{`.`}</li>
    </ul>
    <p>{`Not supported by all npm commands.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`preid`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: ""`}</li>
      <li parentName="ul">{`Type: String`}</li>
    </ul>
    <p>{`The "prerelease identifier" to use as a prefix for the "prerelease" part of
a semver. Like the `}<inlineCode parentName="p">{`rc`}</inlineCode>{` in `}<inlineCode parentName="p">{`1.2.0-rc.8`}</inlineCode>{`.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`sign-git-tag`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`If set to true, then the `}<inlineCode parentName="p">{`npm version`}</inlineCode>{` command will tag the version using
`}<inlineCode parentName="p">{`-s`}</inlineCode>{` to add a signature.`}</p>
    <p>{`Note that git requires you to have set up GPG keys in your git configs for
this to work properly.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`workspace`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default:`}</li>
      <li parentName="ul">{`Type: String (can be set multiple times)`}</li>
    </ul>
    <p>{`Enable running a command in the context of the configured workspaces of the
current project while filtering by running only the workspaces defined by
this configuration option.`}</p>
    <p>{`Valid values for the `}<inlineCode parentName="p">{`workspace`}</inlineCode>{` config are either:`}</p>
    <ul>
      <li parentName="ul">{`Workspace names`}</li>
      <li parentName="ul">{`Path to a workspace directory`}</li>
      <li parentName="ul">{`Path to a parent workspace directory (will result in selecting all
workspaces within that folder)`}</li>
    </ul>
    <p>{`When set for the `}<inlineCode parentName="p">{`npm init`}</inlineCode>{` command, this may be set to the folder of a
workspace which does not yet exist, to create the folder and set it up as a
brand new workspace within the project.`}</p>
    <p>{`This value is not exported to the environment for child processes.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`workspaces`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: null`}</li>
      <li parentName="ul">{`Type: null or Boolean`}</li>
    </ul>
    <p>{`Set to true to run the command in the context of `}<strong parentName="p">{`all`}</strong>{` configured
workspaces.`}</p>
    <p>{`Explicitly setting this to false will cause commands like `}<inlineCode parentName="p">{`install`}</inlineCode>{` to
ignore workspaces altogether. When not set explicitly:`}</p>
    <ul>
      <li parentName="ul">{`Commands that operate on the `}<inlineCode parentName="li">{`node_modules`}</inlineCode>{` tree (install, update, etc.)
will link workspaces into the `}<inlineCode parentName="li">{`node_modules`}</inlineCode>{` folder. - Commands that do
other things (test, exec, publish, etc.) will operate on the root project,
`}<em parentName="li">{`unless`}</em>{` one or more workspaces are specified in the `}<inlineCode parentName="li">{`workspace`}</inlineCode>{` config.`}</li>
    </ul>
    <p>{`This value is not exported to the environment for child processes.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`workspaces-update`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: true`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`If set to true, the npm cli will run an update after operations that may
possibly change the workspaces installed to the `}<inlineCode parentName="p">{`node_modules`}</inlineCode>{` folder.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`include-workspace-root`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Include the workspace root when workspaces are enabled for a command.`}</p>
    <p>{`When false, specifying individual workspaces via the `}<inlineCode parentName="p">{`workspace`}</inlineCode>{` config, or
all workspaces via the `}<inlineCode parentName="p">{`workspaces`}</inlineCode>{` flag, will cause npm to operate only on
the specified workspaces, and not on the root project.`}</p>
    <p>{`This value is not exported to the environment for child processes.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS END */
    }
    <h3>{`Description`}</h3>
    <p>{`Run this in a package directory to bump the version and write the new data
back to `}<inlineCode parentName="p">{`package.json`}</inlineCode>{`, `}<inlineCode parentName="p">{`package-lock.json`}</inlineCode>{`, and, if present,
`}<inlineCode parentName="p">{`npm-shrinkwrap.json`}</inlineCode>{`.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`newversion`}</inlineCode>{` argument should be a valid semver string, a valid second
argument to `}<a parentName="p" {...{
        "href": "https://github.com/npm/node-semver#functions"
      }}>{`semver.inc`}</a>{` (one
of `}<inlineCode parentName="p">{`patch`}</inlineCode>{`, `}<inlineCode parentName="p">{`minor`}</inlineCode>{`, `}<inlineCode parentName="p">{`major`}</inlineCode>{`, `}<inlineCode parentName="p">{`prepatch`}</inlineCode>{`, `}<inlineCode parentName="p">{`preminor`}</inlineCode>{`, `}<inlineCode parentName="p">{`premajor`}</inlineCode>{`,
`}<inlineCode parentName="p">{`prerelease`}</inlineCode>{`), or `}<inlineCode parentName="p">{`from-git`}</inlineCode>{`. In the second case, the existing version will
be incremented by 1 in the specified field.  `}<inlineCode parentName="p">{`from-git`}</inlineCode>{` will try to read
the latest git tag, and use that as the new npm version.`}</p>
    <p>{`If run in a git repo, it will also create a version commit and tag.  This
behavior is controlled by `}<inlineCode parentName="p">{`git-tag-version`}</inlineCode>{` (see below), and can be
disabled on the command line by running `}<inlineCode parentName="p">{`npm --no-git-tag-version version`}</inlineCode>{`.
It will fail if the working directory is not clean, unless the `}<inlineCode parentName="p">{`-f`}</inlineCode>{` or
`}<inlineCode parentName="p">{`--force`}</inlineCode>{` flag is set.`}</p>
    <p>{`If supplied with `}<inlineCode parentName="p">{`-m`}</inlineCode>{` or `}<inlineCode parentName="p">{`--message`}</inlineCode>{` config option, npm will use it as a
commit message when creating a version commit.  If the `}<inlineCode parentName="p">{`message`}</inlineCode>{` config
contains `}<inlineCode parentName="p">{`%s`}</inlineCode>{` then that will be replaced with the resulting version number.
For example:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm version patch -m "Upgrade to %s for reasons"
`}</code></pre>
    <p>{`If the `}<inlineCode parentName="p">{`sign-git-tag`}</inlineCode>{` config is set, then the tag will be signed using the
`}<inlineCode parentName="p">{`-s`}</inlineCode>{` flag to git.  Note that you must have a default GPG key set up in your
git config for this to work properly.  For example:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`$ npm config set sign-git-tag true
$ npm version patch

You need a passphrase to unlock the secret key for
user: "isaacs (http://blog.izs.me/) <i@izs.me>"
2048-bit RSA key, ID 6C481CF6, created 2010-08-31

Enter passphrase:
`}</code></pre>
    <p>{`If `}<inlineCode parentName="p">{`preversion`}</inlineCode>{`, `}<inlineCode parentName="p">{`version`}</inlineCode>{`, or `}<inlineCode parentName="p">{`postversion`}</inlineCode>{` are in the `}<inlineCode parentName="p">{`scripts`}</inlineCode>{` property
of the package.json, they will be executed as part of running `}<inlineCode parentName="p">{`npm
version`}</inlineCode>{`.`}</p>
    <p>{`The exact order of execution is as follows:`}</p>
    <ol>
      <li parentName="ol">{`Check to make sure the git working directory is clean before we get
started.  Your scripts may add files to the commit in future steps.
This step is skipped if the `}<inlineCode parentName="li">{`--force`}</inlineCode>{` flag is set.`}</li>
      <li parentName="ol">{`Run the `}<inlineCode parentName="li">{`preversion`}</inlineCode>{` script. These scripts have access to the old
`}<inlineCode parentName="li">{`version`}</inlineCode>{` in package.json.  A typical use would be running your full
test suite before deploying.  Any files you want added to the commit
should be explicitly added using `}<inlineCode parentName="li">{`git add`}</inlineCode>{`.`}</li>
      <li parentName="ol">{`Bump `}<inlineCode parentName="li">{`version`}</inlineCode>{` in `}<inlineCode parentName="li">{`package.json`}</inlineCode>{` as requested (`}<inlineCode parentName="li">{`patch`}</inlineCode>{`, `}<inlineCode parentName="li">{`minor`}</inlineCode>{`,
`}<inlineCode parentName="li">{`major`}</inlineCode>{`, etc).`}</li>
      <li parentName="ol">{`Run the `}<inlineCode parentName="li">{`version`}</inlineCode>{` script. These scripts have access to the new `}<inlineCode parentName="li">{`version`}</inlineCode>{`
in package.json (so they can incorporate it into file headers in
generated files for example).  Again, scripts should explicitly add
generated files to the commit using `}<inlineCode parentName="li">{`git add`}</inlineCode>{`.`}</li>
      <li parentName="ol">{`Commit and tag.`}</li>
      <li parentName="ol">{`Run the `}<inlineCode parentName="li">{`postversion`}</inlineCode>{` script. Use it to clean up the file system or
automatically push the commit and/or tag.`}</li>
    </ol>
    <p>{`Take the following example:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "scripts": {
    "preversion": "npm test",
    "version": "npm run build && git add -A dist",
    "postversion": "git push && git push --tags && rm -rf build/temp"
  }
}
`}</code></pre>
    <p>{`This runs all your tests and proceeds only if they pass. Then runs your
`}<inlineCode parentName="p">{`build`}</inlineCode>{` script, and adds everything in the `}<inlineCode parentName="p">{`dist`}</inlineCode>{` directory to the commit.
After the commit, it pushes the new commit and tag up to the server, and
deletes the `}<inlineCode parentName="p">{`build/temp`}</inlineCode>{` directory.`}</p>
    <h3>{`See Also`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-init"
        }}>{`npm init`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-run-script"
        }}>{`npm run-script`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/using-npm/scripts"
        }}>{`npm scripts`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/configuring-npm/package-json"
        }}>{`package.json`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/using-npm/config"
        }}>{`config`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      